import { useEffect, useRef, useState } from 'react';
import { Button } from '../ui/button';
import { extractErrorMessage, detailToMessage } from '../../utils/apiErrors';

export const LETTERHEAD_API = `${process.env.REACT_APP_BACKEND_URL}/api/report-letterhead`;

export async function reportError(error) {
  if (error?.response?.data instanceof Blob) {
    try { return detailToMessage(JSON.parse(await error.response.data.text()).detail) || 'Unable to export report'; } catch { /* non-JSON download error */ }
  }
  return extractErrorMessage(error, 'Unable to export report');
}

export const useLetterheadExport = (prefix) => {
  const task = useRef(null), alive = useRef(true), running = useRef(false);
  const [busy, setBusy] = useState(false), [error, setError] = useState('');
  useEffect(() => { alive.current = true; return () => { alive.current = false; }; }, []);
  const requestExport = async (callback) => {
    if (running.current) return;
    running.current = true; task.current = callback;
    setBusy(true); setError('');
    try { await callback(); task.current = null; }
    catch (e) { const message = await reportError(e); if (alive.current) setError(message); }
    finally { running.current = false; if (alive.current) setBusy(false); }
  };
  const exportFeedback = error ? <div role="alert" className="basis-full min-w-0 text-sm text-red-700 break-words" data-testid={`${prefix}-error`}>
    <span>{error}</span><div className="flex flex-wrap gap-2 mt-2"><Button variant="outline" disabled={busy} onClick={() => task.current && requestExport(task.current)} data-testid={`${prefix}-retry`}>Retry export</Button><Button variant="outline" disabled={busy} onClick={() => { setError(''); task.current = null; }} data-testid={`${prefix}-dismiss`}>Dismiss</Button></div>
  </div> : busy ? <p role="status" className="text-sm text-slate-600" data-testid={`${prefix}-progress`}>Exporting report…</p> : null;
  return { requestExport, exportFeedback, exporting: busy };
};